var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 20,
    viewBox: "0 0 12 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_910_8791)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.99971 16.25C5.63675 16.25 5.35156 15.975 5.35156 15.625V4.375C5.35156 4.025 5.63675 3.75 5.99971 3.75C6.36267 3.75 6.64786 4.025 6.64786 4.375V15.625C6.64786 15.975 6.36267 16.25 5.99971 16.25Z",
    fill: "#242424"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.00159 17.4996C5.91659 17.5006 5.8323 17.4844 5.75417 17.4521C5.67603 17.4198 5.60576 17.3721 5.54789 17.3121L1.01085 12.9371C0.751591 12.6871 0.751591 12.2996 1.01085 12.0496C1.27011 11.7996 1.67196 11.7996 1.93122 12.0496L6.01455 15.9871L10.0979 12.0496C10.3571 11.7996 10.759 11.7996 11.0183 12.0496C11.2775 12.2996 11.2775 12.6871 11.0183 12.9371L6.48122 17.3121C6.35159 17.4371 6.18307 17.4996 6.02752 17.4996H6.00159Z",
    fill: "#242424"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_910_8791"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 11.6667,
    height: 20,
    fill: "white",
    transform: "translate(0.164062)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDown);
export default __webpack_public_path__ + "static/media/arrow_down.b7e9b68f6b3154d09f4f5417d065e40a.svg";
export { ForwardRef as ReactComponent };